import SettingsRouter from "./SettingsRouter";

export default SettingsRouter;
